import logo from "../logo.svg";
import "../App.css";
import BootstrapCarousel from "../components/BootstrapCarousel";

function HomePage() {
  return (
    <div className="App">
    <BootstrapCarousel />
    </div>
  );
}

export default HomePage;
